import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
    SignataireJsonldReadCollectionTimestampableBlameambleGroup as SignataireType,
    DemandeurJsonldReadCollectionTimestampableBlameambleGroup,
    DocumentJsonldReadCollectionTimestampableBlameambleGroup as DocumentType,
    LogJsonldReadCollectionTimestampableBlameambleGroup as LogType,
    DossierJsonldReadCollectionTimestampableBlameambleGroup,
    ConfigurationParameters,
    Configuration as DossierSignatureConfiguration,
} from '../../openApi/ApiSign';
import { SIGNATURE_REDUCER_NAME } from './constants';
import { buildSignRedux } from './signatureReducer';

const { reducer } = buildSignRedux({});

type DossierSignatureApiObject = DossierJsonldReadCollectionTimestampableBlameambleGroup &
    Record<string, unknown>;

type DossierSignature = DossierSignatureApiObject & {
    signataires: SignataireType[];
};

type DemandeurSignatureApiObject = DemandeurJsonldReadCollectionTimestampableBlameambleGroup &
    Record<string, unknown>;

type DemandeurSignature = DemandeurSignatureApiObject;

export { DossierSignatureConfiguration };

export {
    type ConfigurationParameters as DossierSignatureConfigurationParameters,
    type SignataireType,
    type LogType,
    type DemandeurSignatureApiObject,
    type DemandeurSignature,
    type DocumentType,
    type DossierSignatureApiObject,
    type DossierSignature,
};

export const signReducer = combineReducers({
    [SIGNATURE_REDUCER_NAME]: reducer,
});

export const signStore = configureStore({
    reducer: signReducer,
    devTools: {
        name: 'Signatures Store',
    },
});

export type SignReducerType = typeof signReducer;
export type SignStateType = ReturnType<typeof signStore.getState>;
export type SignAppDispatch = typeof signStore.dispatch;
